import React from "react";
import { Theme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Booking, BookingTypeEnum } from "@bn/api/apiv1";
import { Modal } from "@components";
import { EditTransactionWizard } from "@features/transactionWizard/EditTransactionWizard";
import { EditDividendWizard } from "@features/dividendWizard/EditDividendWizard";

const DIVIDEND_TYPES: BookingTypeEnum[] = [
  "dividend",
  "purchase_right",
  "pre_tax_allowance",
  "retained_dividend",
];

export const isBookingEditable = (type: BookingTypeEnum) =>
  type !== "split" && type !== "reverse_split";

export const isDividendBooking = (type: BookingTypeEnum) =>
  DIVIDEND_TYPES.includes(type);

export interface Props {
  booking: Booking | undefined;
  investmentId: number;
  image?: string | null;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const EditBookingModal = ({
  booking,
  investmentId,
  image,
  isOpen,
  onClose,
  onSuccess,
}: Props) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  if (!booking) return null;

  const isDividend = isDividendBooking(booking.type);
  const title = isDividend
    ? t("editDividendWizard.title")
    : t("transactionWizard.edit.title");

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width={isMobile ? "auto" : 720}
      height="auto"
      maxHeight={isMobile ? "650px" : "100%"}
      position={isMobile ? "bottom" : "centered"}
      zIndex={10001}
      disablePortal={false}
    >
      {isDividend ? (
        <EditDividendWizard
          key={booking.id}
          investmentId={investmentId}
          bookingId={booking.id}
          image={image}
          onSuccess={onSuccess}
        />
      ) : (
        <EditTransactionWizard
          key={booking.id}
          id={booking.id}
          image={image}
          onSuccess={onSuccess}
        />
      )}
    </Modal>
  );
};
